<template>
  <div>
    <ul class="block p-0 ml-4 list-unstyled tabs-nav">
      <li
        v-for="(tab, tabIndex) in tabs"
        :key="tab.title"
        class="p-4 rounded m-0 inline-block cursor-pointer"
        :class="{'bg-indigo text-white': selected(tabIndex)}"
        @click="select(tabIndex)"
      >
        {{ tab.title }}
      </li>
    </ul>

    <slot />
  </div>
</template>

<script>
export default {
  data() {
    return {
      index: 0,
      tabs: [],
    }
  },
  created() {
    this.tabs = this.$children
  },
  mounted() {
    this.select(0)
  },
  methods: {
    select(index) {
      this.index = index

      this.tabs.forEach((tab, tabIndex) => tab.active = index === tabIndex)
    },
    selected(tabIndex) {
      return tabIndex === this.index
    },
  },
}
</script>
